/**
 * utils/validators.js
 * Все функции валидации форм.
 * Возвращают строку с ошибкой или null если поле валидно.
 */

/** Валидация email */
export function validateEmail(value) {
  if (!value || !value.trim()) return 'Email is required';
  const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  if (!re.test(value.trim())) return 'Invalid email address';
  return null;
}

/** Валидация телефона (международный формат, минимум 7 цифр) */
export function validatePhone(value) {
  if (!value || !value.trim()) return null; // телефон необязателен
  const digits = value.replace(/\D/g, '');
  if (digits.length < 7) return 'Phone number is too short';
  return null;
}

/** Валидация имени */
export function validateName(value) {
  if (!value || !value.trim()) return 'Name is required';
  if (value.trim().length < 2) return 'Name is too short';
  return null;
}

/** Валидация названия компании */
export function validateCompany(value) {
  if (!value || !value.trim()) return 'Company name is required';
  return null;
}

/** Валидация вопроса */
export function validateQuestion(value) {
  if (!value || !value.trim()) return 'Please enter your question';
  if (value.trim().length < 5) return 'Question is too short';
  return null;
}

/** Группированная валидация формы контактов */
export function validateContactsForm({ name, company, email, phone }) {
  return {
    name: validateName(name),
    company: validateCompany(company),
    email: validateEmail(email),
    phone: validatePhone(phone),
  };
}

/** Возвращает true если объект ошибок не содержит ненулевых значений */
export function isFormValid(errors) {
  return Object.values(errors).every(e => e === null);
}
